
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as HeartIcon } from "../fontello/icons/svg/ic_heart.svg"


const Heart = ({ ...props }) => (
  <SvgIcon
    component={HeartIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Heart
